import units from "utils/units"
import { convertKilometersToMiles } from "utils/units/helpers"
import { BaseComponent, BElement } from "utils/base-component"

import "./index.scss"

type Config = {
  onChange: (value: number) => void
}

export class DistanceRangeSlider extends BaseComponent<Config> {
  static cssClass = "distance-range-slider"

  input!: HTMLInputElement
  label!: BElement
  labelMaxValue!: BElement
  labelDistance!: BElement
  labelDistanceUnits!: BElement

  init() {
    this.input = this.element("input")!.element as HTMLInputElement
    this.label = this.element("label")!
    this.labelMaxValue = this.element("label-max-value")!
    this.labelDistance = this.element("label-distance")!
    this.labelDistanceUnits = this.element("label-distance-units")!

    this.input.addEventListener("input", () => this.update())
    this.update()
  }

  get min() {
    return Number(this.input.min)
  }

  get max() {
    return Number(this.input.max)
  }

  get value() {
    return Number(this.input.value)
  }

  update() {
    this.updateDistance()
    this.updateLabelPositionX()
    this.config.onChange(this.getDistance())
  }

  private updateDistance() {
    const shouldShowDistance = this.value < this.max

    if (shouldShowDistance) {
      let distance = this.getDistance()
      if (units.current.length === "Imperial") {
        distance = convertKilometersToMiles(distance, { precision: 1 })
      }
      this.labelDistance.element.textContent = String(distance)
    }

    this.labelMaxValue.toggleModifier("is-hidden", shouldShowDistance)
    this.labelDistance.toggleModifier("is-hidden", !shouldShowDistance)
    this.labelDistanceUnits.toggleModifier("is-hidden", !shouldShowDistance)
  }

  // TODO: pass in the stops via data- attribute maybe?
  private getDistance() {
    let distance = this.value

    if (distance === 140) distance = 50
    else if (distance === 260) distance = 100
    else if (distance === 380) distance = 250

    return distance
  }

  private updateLabelPositionX() {
    const percent = this.getRangePercent()
    const left = percent * 100
    const emAdjust = percent * 1.5

    this.label.element.style.setProperty("left", `calc(${left}% - ${emAdjust}em)`)
  }

  private getRangePercent() {
    const relativeValue = this.value - this.min
    const ticks = this.max - this.min
    const percent = relativeValue / ticks

    return percent
  }
}
